export class LinkedAssessmentModel {
    impactAssessmentId: number;
    templateNumber:number;
    linkedAssessment: Array<number>;

    constructor() {
        this.impactAssessmentId = 0;
        this.linkedAssessment = [];
        this.templateNumber = 0;
    }
}